import api from "../axiosInstance";

export const createOrder = async (orderData) => {
    const response = await api.post("/orders", orderData);
    return response.data;
};

export const getUserOrders = async () => {
    const response = await api.get("/orders");
    return response.data;
};

export const getOrderById = async (orderId) => {
    const response = await api.get(`/orders/${orderId}`);  // ✅ FIX
    return response.data;
};

export const cancelOrder = async (orderId) => {
    const response = await api.delete(`/orders/${orderId}`);  // ✅ FIX
    return response.data;
};

// ========== ADMIN ENDPOINTS ==========

export const getAllOrders = async () => {
    const response = await api.get("/orders/admin/all");
    return response.data;
};

export const getPendingOrders = async () => {
    const response = await api.get("/orders/admin/pending");
    return response.data;
};

export const getDeliveredOrders = async () => {
    const response = await api.get("/orders/admin/delivered");
    return response.data;
};

export const updateOrderStatus = async (orderId, status) => {
    const response = await api.patch(`/orders/admin/${orderId}/status`, null, {  // ✅ FIX
        params: { status }
    });
    return response.data;
};